import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Input } from "rbx";

function CurrencyInput({ name, value, size, onChange, readOnly }) {
  return (
    <Field>
      <Control size={size}>
        <Input
          autocomplete="new"
          disabled={readOnly}
          name={name}
          readOnly={readOnly}
          size={size}
          type="text"
          value={value}
          onChange={onChange}
        />
      </Control>
    </Field>
  );
}

CurrencyInput.propTypes = {
  value: PropTypes.number,
  name: PropTypes.string,
  size: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func
};

export default CurrencyInput;
